import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ClockIcon, SmartphoneIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CTA_LABEL, PRICE } from '../data/content';
const trustItems = [{
  icon: ClockIcon,
  label: 'Menos de 10 minutos'
}, {
  icon: SmartphoneIcon,
  label: 'iPhone y Android'
}, {
  icon: ShieldCheckIcon,
  label: 'Sin saber de tecnología'
}];
export function Hero() {
  return <header className="relative overflow-hidden border-b border-ink-700 bg-ink-900" data-id="element-53" data-mp="128yzydv6bxz6">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.14]" style={{
      backgroundImage: 'linear-gradient(to right, #F5B301 1px, transparent 1px), linear-gradient(to bottom, #F5B301 1px, transparent 1px)',
      backgroundSize: '56px 56px',
      maskImage: 'radial-gradient(ellipse 70% 60% at 50% 0%, black, transparent)',
      WebkitMaskImage: 'radial-gradient(ellipse 70% 60% at 50% 0%, black, transparent)'
    }} data-id="element-54" data-mp="xbpawzbp5obv" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-5 py-14 text-center sm:py-20" data-id="element-55" data-mp="3j8sdtwfflbnq">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-6 inline-flex items-center gap-2 rounded-full border border-shield-500/40 bg-shield-500/10 px-4 py-1.5" data-id="element-56" data-mp="3o859n6oa5t2g">
          <ShieldCheckIcon className="h-4 w-4 text-shield-500" aria-hidden="true" data-id="element-57" data-mp="30h9cdu1225nt" />
          <span className="text-xs font-bold uppercase tracking-[0.18em] text-shield-400" data-id="element-58" data-mp="358zoo5jjz3hv">
            Escudo Digital 2025
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease: 'easeOut'
      }} className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-5xl" data-id="element-59" data-mp="2qi0nvgoylj8u">
          No esperes a que te vacíen la cuenta:{' '}
          <span className="text-shield-500" data-id="element-60" data-mp="s3cki77jpdoz">blindá tu WhatsApp y tus ahorros</span> en menos de 10
          minutos.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.15,
        ease: 'easeOut'
      }} className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-61" data-mp="ibyrmia3nc4t">
          El método paso a paso para convertir tu celular en una fortaleza impenetrable, sin
          necesidad de ser un experto en tecnología.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.25,
        ease: 'easeOut'
      }} className="mt-9 flex w-full flex-col items-center" data-id="element-62" data-mp="110wp9q4m9s4c">
          <CtaButton label={CTA_LABEL} sublabel={`${PRICE} ARS · Pago único`} data-id="element-63" data-mp="3hqagchhnuxhc" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-64" data-mp="1x9ukuaytndnf">
            {trustItems.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-sm text-slate-400" data-id="element-65" data-mp="218juptknid2b">
                <Icon className="h-4 w-4 text-safe-500" aria-hidden="true" data-id="element-66" data-mp="267wluqik26ap" />
                {label}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </header>;
}